export default "__VITE_ASSET__CziXe5Ku__"